const initialState = () => ({
  isOpened: false,
  action: null,
  entity: {},
  onSuccessCallback: null,
  loading: false,
  error: null
});

const ACTION_KEY = 'SIMPLE_FORM_MODAL';

const reducer = (state = initialState(), reduxAction) => {
  switch (reduxAction.type) {
    case `${ACTION_KEY}_OPEN`: {
      const { entity, action, onSuccessCallback } = reduxAction.payload;
      return {
        ...state,
        isOpened: true,
        action,
        entity,
        onSuccessCallback
      };
    }

    case `${ACTION_KEY}_CLOSE`: {
      return initialState();
    }

    case `${ACTION_KEY}_PENDING`: {
      return {
        ...state,
        loading: true,
        error: null
      };
    }

    case `${ACTION_KEY}_REJECTED`: {
      return {
        ...state,
        loading: false,
        error: reduxAction.payload
      };
    }
    case `${ACTION_KEY}_FULFILLED`: {
      return initialState();
    }

    default:
      return state;
  }
};

export default reducer;
